import React, { useEffect } from "react";
import "./Title.css";
const Title = () => {
  useEffect(() => {
    document.title = "Company core values creator | Mesh";
  }, []);
  return (
    <div className="title_data_core">
      Align yourself to an emoji that best represents your response. Remember,
      there's no such thing as a wrong answer!
    </div>
  );
};

export default Title;
